import {
  ADMIN_BROKER_SERVERS_PATH,
  ADMIN_BREACH_EVENTS_PATH,
  ADMIN_METRICS_BY_COUNTRY_CHART_PATH,
  ADMIN_METRICS_BY_COUNTRY_PATH,
  ADMIN_METRICS_PATH,
  ADMIN_REGISTRATION_PLATFORM_METRICS_PATH,
  GET_TRADING_LOG_STATS,
  GET_PLATFORM_REQUEST_STATS,
  GET_TRACKED_LINK_CLICK_COUNTRY_STATS,
  GET_TRACKED_LINK_CLICK_STATS,
  GET_USER_QUESTIONNAIRE_STATS,
} from '../../../../constants'
import AbstractService from '../../../../services/AbstractService'

import {
  GetAdminDashboardMetricsRequest,
  GetAdminDashboardMetricsResponse,
  GetAdminDashboardMetricsByCountryRequest,
  GetAdminDashboardMetricsByCountryChartRequest,
  GetAdminDashboardMetricsByCountryChartResponse,
  GetAdminBrokerServersRequest,
  GetAdminBrokerServersResponse,
  GetTradingLogStatsRequest,
  GetTradingLogStatsResponse,
  GetQuestionnaireStatsRequest,
  GetPlatformRequestStatsRequest,
  GetPlatformRequestStatsResponse,
  GetAdminRegistrationPlatformMetricsRequest,
  GetAdminRegistrationPlatformMetricsResponse,
  GetAdminBreachEventsRequest,
  GetAdminBreachEventsResponse,
  GetTrackedLinkClickCountryStatsRequest,
  GetTrackedLinkClickCountryStatsResponse,
  GetTrackedLinkClickStatsRequest,
  GetTrackedLinkClickStatsResponse,
  QuestionnaireStatsResponse,
} from './types'

class AdminDashboardServiceClass extends AbstractService {
  getMetrics = (data: GetAdminDashboardMetricsRequest) => {
    return this.request<GetAdminDashboardMetricsResponse>(ADMIN_METRICS_PATH, 'post', false, data)
  }

  getBreachEvents = (data?: GetAdminBreachEventsRequest) => {
    return this.request<GetAdminBreachEventsResponse>(ADMIN_BREACH_EVENTS_PATH, 'post', false, data)
  }

  getMetricsByCountry = (data: GetAdminDashboardMetricsByCountryRequest) => {
    return this.request<GetAdminDashboardMetricsResponse>(
      ADMIN_METRICS_BY_COUNTRY_PATH,
      'post',
      false,
      data,
    )
  }

  getRegistrationPlatformMetrics = (data: GetAdminRegistrationPlatformMetricsRequest) => {
    return this.request<GetAdminRegistrationPlatformMetricsResponse>(
      ADMIN_REGISTRATION_PLATFORM_METRICS_PATH,
      'post',
      false,
      data,
    )
  }

  getMetricsByCountryChart = (data: GetAdminDashboardMetricsByCountryChartRequest) => {
    return this.request<GetAdminDashboardMetricsByCountryChartResponse>(
      ADMIN_METRICS_BY_COUNTRY_CHART_PATH,
      'post',
      false,
      data,
    )
  }

  getBrokerServers = (data: GetAdminBrokerServersRequest) => {
    return this.request<GetAdminBrokerServersResponse>(
      ADMIN_BROKER_SERVERS_PATH,
      'post',
      false,
      data,
    )
  }

  getTradingLogStats = (data?: GetTradingLogStatsRequest) => {
    return this.request<GetTradingLogStatsResponse>(GET_TRADING_LOG_STATS, 'post', false, data)
  }

  getUserQuestionnaireStats = (data?: GetQuestionnaireStatsRequest) => {
    return this.request<QuestionnaireStatsResponse>(
      GET_USER_QUESTIONNAIRE_STATS,
      'post',
      false,
      data,
    )
  }

  getPlatformRequestStats = (data?: GetPlatformRequestStatsRequest) => {
    return this.request<GetPlatformRequestStatsResponse>(
      GET_PLATFORM_REQUEST_STATS,
      'post',
      false,
      data,
    )
  }

  getTrackedLinkClickStats = (data?: GetTrackedLinkClickStatsRequest) => {
    return this.request<GetTrackedLinkClickStatsResponse>(
      GET_TRACKED_LINK_CLICK_STATS,
      'post',
      false,
      data,
    )
  }

  getTrackedLinkClickCountryStats = (data?: GetTrackedLinkClickCountryStatsRequest) => {
    return this.request<GetTrackedLinkClickCountryStatsResponse>(
      GET_TRACKED_LINK_CLICK_COUNTRY_STATS,
      'post',
      false,
      data,
    )
  }
}

export const AdminDashboardService = new AdminDashboardServiceClass()
